<template>
  <div class="left-box" :class="{ 'show-foot': showFoot}">
    <div class="left-top">
      <img src="../../../assets/img/camera-icon.png">
      <div class="name">
        {{ devName ? devName : '这是监控名称' }}
      </div>
      <div class="num">
        {{ info.deviceSerial ? info.deviceSerial : '这是监控id' }}
      </div>
    </div>
    <div class="left-content" ref="content">
      <div :id="'videoContainer' + info.deviceSerial"></div>
    </div>
    <div class="video-bottom" v-if="showFoot && foot">
<!--      启动预警-->
<!--      <div class="box2" @click="confirmWarning">启动预警</div>-->
      <div class="box4" v-if="model === 'simple'" @click="startCallBack">监控回放</div>
      <div class="box4" v-else @click="startTalkPattern">对讲模式</div>
      <div class="box2" v-if="false" @click="playerAudio">{{ playTime ? '语音播报' :  playerAudioTime }}</div>
    </div>
<!--    <div v-else class="v-bottom"></div>-->
  </div>
</template>

<script>
import EZUIKit from "../../../plugins/ezuikit";
import {uploadFile} from "../../../api/common";
import { manualReportWarning } from "../../../api/warning";
import {getSettingsInfo} from "../../../api/set";
import { baserUrl } from "../../../plugins/BsaeUrl";
import { playVoice } from "../../../api/device";

export default {
  name: "videoContainer",
  props: {
    info: { type: Object, default: () => {} },
    token: { type: String, default: '' },
    foot: { type: Boolean, default: true }
  },
  data () {
    return {
      player: null,
      model: 'simple', // 对讲模式
      devName: '',
      showFoot: false,
      playerAudioTime: 0,
      intervalTime: null
    }
  },
  watch: {
    info () {
      this.player.stop()
      this.player.play({
        url: this.info.url
      })
    }
  },
  computed: {
    playTime () {
      return this.playerAudioTime <= 0
    }
  },
  mounted() {
    this.devName = this.info.deviceName
    this.handlePlayer()
    this.$bus.on('editDevice', (form) => {
      if (form.deviceSerial && form.deviceSerial === this.info.deviceSerial) {
        this.devName = form.deviceName
      }
    })
  },
  beforeDestroy() {
    this.player.stop()
    this.$bus.off('editInfo');
    if (this.intervalTime !== null) {
      clearInterval(this.intervalTime)
    }
  },
  methods: {
    handlePlayer () {
      this.showFoot = false
      const dom = document.getElementById('videoContainer' + this.info.deviceSerial)
      this.player = new EZUIKit.EZUIKitPlayer({
        id: 'videoContainer' + this.info.deviceSerial, // 视频容器ID
        accessToken: this.token,
        url: this.info.url,
        audio: 0,
        width: dom.offsetWidth,
        height: (dom.offsetWidth / 16 * 9) - 60,
        template: 'simple',
        footer: ['talk', 'broadcast', 'hd', 'fullScreen'],
        handleSuccess: () => {
          this.showFoot = true
        },
        handleError: () => {
          this.showFoot = true
        }
      })
    },
    startTalkPattern () {
      if (this.model === 'simple') return this.$message.warning('当前已经是对讲模式')
      const dom = document.getElementById('videoContainer' + this.info.deviceSerial)
      this.showFoot = false
      this.model = 'simple'
      this.player.stop()
      dom.remove()
      const newDom = document.createElement('div')
      newDom.id = 'videoContainer' + this.info.deviceSerial
      this.$refs.content.append(newDom)
      this.player = new EZUIKit.EZUIKitPlayer({
        id: 'videoContainer' + this.info.deviceSerial, // 视频容器ID
        accessToken: this.token,
        url: this.info.url,
        audio: '0',
        width: newDom.offsetWidth,
        height: (newDom.offsetWidth / 16 * 9) - 50,
        template: 'simple',
        footer: ['talk', 'broadcast', 'hd', 'fullScreen'],
        handleSuccess: () => {
          this.showFoot = true
        },
        handleError: () => {
          this.showFoot = true
        }
      })
    },
    startCallBack () {
      if (this.model === 'security') return this.$message.warning('当前已经是回放模式')
      const dom = document.getElementById('videoContainer' + this.info.deviceSerial)
      const stopTalkDom =  dom.getElementsByClassName('ptp-talk on')[0]
      if (stopTalkDom.classList.length === 2) { // 说明存在 hide 用户点击过开启对讲
        stopTalkDom.click()
      }
      this.showFoot = false
      this.model = 'security'
      this.player.stop()
      dom.remove()
      const newDom = document.createElement('div')
      newDom.id = 'videoContainer' + this.info.deviceSerial
      this.$refs.content.append(newDom)
      this.player = new EZUIKit.EZUIKitPlayer({
        id: 'videoContainer' + this.info.deviceSerial, // 视频容器ID
        accessToken: this.token,
        url: this.info.url,
        audio: '0',
        width: newDom.offsetWidth,
        height: (newDom.offsetWidth / 16 * 9),
        template: 'security',
        footer: ['talk', 'broadcast', 'hd', 'fullScreen'],
        handleSuccess: () => {
          this.showFoot = true
        },
        handleError: () => {
          this.showFoot = true
        }
      })
    },
    confirmWarning() {
      this.$confirm('启动报警, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.startWarning()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消报警'
        });
      });
    },
    startWarning () {
      this.player.capturePicture('screenshot', true).then(res => {
        let blob = new Blob([res.data.fileUint8Array], { type: 'image/jpeg' });
        let file = new window.File([blob], new Date().getTime() + 'screenshot.jpeg', { type: 'image/jpeg' })
        let formData = new FormData()
        formData.append('file', file)
        uploadFile(formData).then(upFile => {
          manualReportWarning({
            deviceName: this.devName || '',
            deviceSerial: this.info.deviceSerial,
            eventImg: upFile.data,
            deviceType: 0
          }).then(() =>{
            this.$message.success('操作成功！')
            this.$bus.emit('refreshWarning')
          })
        })
      })
    },
    playerAudio () {
      if (this.playerAudioTime > 0) return this.$message.warning('语音未结束！')
      getSettingsInfo().then(res => {
        if (!res.data.warningUrl) return this.$message.warning('未配置播报语音')
        const audioDom = document.createElement("audio"); //生成一个audio元素
        audioDom.src = `${baserUrl}${res.data.warningUrl}`; //音乐的路径
        audioDom.addEventListener("canplay",  () => {
          const form = {
            length: audioDom.duration,
            deviceSerial: this.info.deviceSerial,
            type: 0,
            channel: this.info.channel
          }
          playVoice(form).then(res => {
            this.playerAudioTime = res.data
            this.intervalTime = setInterval(()=>{
              this.playerAudioTime--
              if (this.playerAudioTime <= 0) {
                clearInterval(this.intervalTime)
              }
            },1000)
          })
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.left-box{
  //height: 455px;
  background-image: url("../../../assets/img/left-box-bg.png");
  background-size: 100% 100%;
  padding: 2px 6px 10px 5px;
  .left-top{
    padding: 5px 15px;
    display: flex;
    flex-wrap: wrap;
    font-size: 16px;
    position: relative;
    img{
      width: 24px;
      height: auto;
      margin-right: 5px;
    }
    .num{
      position: absolute;
      right: 10px;
    }
  }
  .v-bottom{
    height: 10px;
    width: 91.7%;
    margin-left: 8.6%;
    background-image: url("../../../assets/home/video-bottom.png");
    background-size: 100% 100%;
    position: relative;
    &:before{
      content: '';
      display: block;
      width: calc(100% - 4px);
      height: 3px;
      position: absolute;
      top: -1px;
      background-color: #3D3D3D;
    }
    //top: -2px;
  }
  .left-content{
    width: calc(100% - 3px);
    margin: 0 1px 0px 2px;
    background-color: #3D3D3D;
  }
  .video-bottom{
    height: 55px;
    display: flex;
    justify-content: center;
    padding-top: 5px;
    div{
      width: 160px;
      height: 50px;
      background-size: 100% 100%;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;
    }
    .box2{
      background-image: url("../../../assets/img/box2.png");
      color: #00FFF6;
    }
    .box4{
      background-image: url("../../../assets/img/box4.png");
      color: #00B2FF;
    }
  }
}
/deep/.audio-controls{
  display: none;
}
/deep/.broadcast{
  display: none !important;
}
.show-foot{
  /deep/.audio-controls{
    display: block;
  }
}
.foot{
  padding-bottom: 2px;
}
</style>
